export default "__VITE_ASSET__Ezlm0QW4__"